<template>
  <div id="whereAutoComplete">
    <div v-if="displayListLocations" :style="autocompletePosLeft" role="listbox" class="short-search-wrapper"
      :class="{ 'place-searches': isAbsolute }" tabindex="0" aria-expanded="true">
      <div v-if="locationListApi.length">
        <ul class="autocomplete-items" role="group" aria-labelledby="popular-searches-title">
          <li v-for="(locationItem, index) in locationListApi.slice(0, 5)"
            :class="{ 'suggestion-highlighted': cursorIndex === index }" role="listbox"
            aria-label="Suggestions de recherche" :key="locationItem" class="search-item">
            <i class="icon-search" aria-hidden="true"></i>
            <a href="#" v-html="$sanitize(locationItem)"
              @click.prevent="$emit('onClickLocationText', htmlStripper(locationItem))" />
          </li>
        </ul>
      </div>
      <div v-else-if="!!noResult" class="autocomplete-no-result">
        <div class="search-item">
          <p class="no-result">
            <i class="icon-danger" aria-hidden="true" /> Aucun résultat
          </p>
        </div>
      </div>
      <div class="geolocation-searches">
        <div class="search-item"
          :class="{ 'suggestion-highlighted': cursorIndex === locationListApi.slice(0, 5).length }" role="listbox"
          aria-label="Suggestions de recherche">
          <button class="search-item-around" type="button" @click="$emit('onClickLocationText', 'Autour de moi')">
            <i class="icon-geolocation" aria-hidden="true"></i> Autour de moi
          </button>
        </div>
      </div>
      <div v-if="locationListHistoyFiltred.length" class="history-searches">
        <div class="autocomplete-title">
          Lieux récents
          <div class="autocomplete-clear autocomplete-processed">
            <button @click="$emit('onClearLocationHistory')" type="button" data-location="1">
              Effacer l’historique
            </button>
          </div>
        </div>
        <ul class="autocomplete-items" role="group" aria-labelledby="history-searches-title">
          <li class="search-item" v-for="(locationItem, index) in locationListHistoyFiltred.slice(0, 3)" role="listbox"
            aria-label="Suggestions de recherche"
            :class="{ 'suggestion-highlighted': cursorIndex === (index + 1 + locationListApi.slice(0, 5).length) }"
            :key="locationItem">
            <i class="icon-history" aria-hidden="true"></i>
            <a href="#" @click.prevent="$emit('onClickLocationText', locationItem)">{{ locationItem }}</a><button
              type="button" @click="$emit('onRemoveLocationItem', locationItem)" class="clear-item-search">
              <i class="icon-close" aria-hidden="true"></i>
              <span class="sr-only">Supprimer</span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from 'vue';
import { htmlStripper } from '@/helpers';

export default {
  props: {
    displayListLocations: { type: Boolean, default: false },
    autocompleteWherePosTop: { type: String, default: '' },
    locationListApi: { type: Array, default: () => ([]) },
    locationListHistoyFiltred: { type: Array, default: () => ([]) },
    cursorIndex: { type: Number, default: null },
    isAbsolute: { type: Boolean, default: true },
    noResult: { type: Boolean, default: false },
  },
  emits: ['onClearLocationHistory', 'onRemoveLocationItem'],
  setup() {
    const isExternalMode = inject('isExternalMode');
    return {
      htmlStripper,
      isExternalMode,
    };
  },

};

</script>

<style lang="scss">
.place-searches-top {
  top: 127px !important;
}
</style>
